<template>
    <div v-if="selectedStudio" class="bg-white shadow overflow-hidden sm:rounded-lg w-full sm:mt-6">
      <div class="bg-white px-4 py-5 sm:px-6">
        <div class="flex space-x-3">
          <div class="min-w-0 flex-1">
            <p class="text-sm font-medium text-gray-900">
              <a class="hover:underline">{{ selectedStudio.city }}, {{ selectedStudio.street }}</a>
            </p>
            <p class="text-sm text-gray-500">
              <a class="hover:underline">{{ selectedStudio.country }}</a>
            </p>
          </div>
          <div class="flex-shrink-0 self-center flex" v-if="user.type!='cleaner'">
            <div class="relative z-30 inline-block text-left">
              <div>
                <button
                  type="button"
                  class="-m-2 p-2 rounded-full flex items-center text-gray-400 hover:text-gray-600"
                  id="menu-0-button"
                  @click="optionsMenu=!optionsMenu"
                >
                  <span class="sr-only">Open options</span>
                  <!-- Heroicon name: solid/dots-vertical -->
                  <svg
                    class="h-5 w-5"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"
                    />
                  </svg>
                </button>
              </div>

              <!--
          Dropdown menu, show/hide based on menu state.

          Entering: "transition ease-out duration-100"
            From: "transform opacity-0 scale-95"
            To: "transform opacity-100 scale-100"
          Leaving: "transition ease-in duration-75"
            From: "transform opacity-100 scale-100"
            To: "transform opacity-0 scale-95"
        -->
              <div
                class="origin-top-right absolute right-0 mt-2 w-36 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
                role="menu"
                v-if="optionsMenu"
              >
                <div class="py-1" role="none">
                  <!-- Active: "bg-gray-100 text-gray-900", Not Active: "text-gray-700" -->
                  <a
                    
                    class="text-gray-700 flex px-4 py-2 text-sm"
                    role="menuitem"
                    tabindex="-1"
                    id="menu-0-item-0"
                  >
                    <router-link :to="{ path: '/studios/edit/' + index }"
                      >Edit Studio</router-link
                    >
                  </a>
                  <!-- <a
                    
                    class="text-gray-700 flex px-4 py-2 text-sm"
                    role="menuitem"
                    tabindex="-1"
                    id="menu-0-item-1"
                    v-if="user.type=='admin'"
                  >
                    <span>Delete Studio</span>
                  </a> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="border-t border-gray-200 px-4 py-5 sm:px-6">
        <dl class="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
          <div class="sm:col-span-1">
            <dt class="text-sm font-medium text-gray-500">Address</dt>
            <dd class="mt-1 text-sm text-gray-900">{{ selectedStudio.country }}</dd>
            <dd class="mt-1 text-sm text-gray-900">{{ selectedStudio.region }}, {{ selectedStudio.city }}, {{ selectedStudio.zipCode }}</dd>
            <dd class="mt-1 text-sm text-gray-900">{{ selectedStudio.street }}</dd>
          </div>
         <div class="sm:col-span-1" v-if="selectedStudio.cleaningCost">
          <dt class="text-sm font-medium text-gray-500">Expected cost</dt>
          <dd class="mt-1 text-sm text-gray-900">
            €
            {{
              selectedStudio.cleaningCost
            }}
          </dd>
        </div>
        <div class="sm:col-span-1" v-if="selectedStudio.cleanerCost">
          <dt class="text-sm font-medium text-gray-500">Expected revenue</dt>
          <dd class="mt-1 text-sm text-gray-900">
            €
            {{
              selectedStudio.cleanerCost
            }}
          </dd>
        </div>
                              <div class="sm:col-span-1" v-if="selectedStudio.startHour && selectedStudio.endHour">
            <dt class="text-sm font-medium text-gray-500">Available between</dt>
            <dd class="mt-1 text-sm text-gray-900">{{selectedStudio.startHour | moment('timezone', 'Europe/Brussels',"HH:mm")}} and {{selectedStudio.endHour | moment('timezone', 'Europe/Brussels',"HH:mm")}}</dd>
          </div>
          
          <div class="sm:col-span-2">
            <dt class="text-sm font-medium text-gray-500">Job description</dt>
            <dd class="mt-1 text-sm text-gray-900">
              {{ selectedStudio.description }}
            </dd>
          </div>
          <div class="sm:col-span-1">
            <dt class="text-sm font-medium text-gray-500">Contact information</dt>
                  <div class="mt-1 flex flex-col justify-stretch space-y-3 sm:flex-row sm:space-y-0 sm:space-x-4">
                    <button @click='gotoLink("mailto:"+selectedStudio.owner.email)' class="inline-flex justify-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-500">
                      <!-- Heroicon name: solid/mail -->
                      <svg class="-ml-1 mr-2 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                        <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                      </svg>
                      <span>Email</span>
                    </button>
                    <button @click='gotoLink("tel:"+selectedStudio.owner.phone)' class="inline-flex justify-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-500">
                      <!-- Heroicon name: solid/phone -->
                      <svg class="-ml-1 mr-2 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                      </svg>
                      <span>Call</span>
                    </button>
                  </div>
          </div>
        </dl>
      </div>
    </div>
</template>

<script lang="ts">
import { mapGetters } from "vuex";

export default {
  name: "jobDetail",
  data() {
    return {
      index: null,
      optionsMenu: false,
      selectedStudio: null
    };
  },
  components: {
  },
  computed: {
        ...mapGetters("user", {
      user: "currentUser",
    }),
    ...mapGetters("studio", {
      studios: "studioList",
    }),
  },
  methods: {
    getStudioById(id){
        let filtered = this.studios.filter(studio => {
        if (studio._id == id) return studio
      })
      return filtered[0]
    },
    gotoLink(url){
      location.href=url;
    }
  },
  mounted() {
    this.index = this.$route.params.index;
    this.selectedStudio = this.getStudioById(this.index);
  },
};
</script>

<style>
</style>

<style></style>